import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=cbef146e&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=cbef146e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef146e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbef146e')) {
      api.createRecord('cbef146e', component.options)
    } else {
      api.reload('cbef146e', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=cbef146e&scoped=true", function () {
      api.rerender('cbef146e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/localization/currencyManage/addModal.vue"
export default component.exports